<template>
  <div class="products-jsn-page-content flex flex-col items-center w-full max-ml:overflow-x-hidden">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem  max-ml:object-cover max-ml:object-center"
        src="/images/pages/products/jsn/jsn-banner.png" alt="" />
      <PageContentCenter class="text-[#fff] absolute top-[136px]">
        <h2 class="text-42.08px text-[#102136] mb-[8px]">
          即时鸟新零售Saas系统
        </h2>
        <p class="text-#7D838D">一店集成 三核驱动 即时零售数字化方案</p>
        <div
          class="rounded-0.5rem overflow-hidden bg-#fff p-1rem  mt-4rem inline-block text-center relative z-2 shadow-md max-ml:hidden">
          <Pic class="w-7.06rem rounded-0.5rem mb-1rem " src="/images/QR-code/jsn.png"></Pic>
          <span class="text-[#102136] text-0.8rem">扫码了解更多</span>
        </div>
      </PageContentCenter>
    </section>

    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/jsn.png"></Pic>
    </section>

    <section class="relative w-full">
      <h2 class="text-42.08px text-[#272E3B] pt-[80px] text-center mb-6.25rem ">
        {{ content.businessIntroduction.title }}
      </h2>
      <PageContentCenter class="text-[#272E3B] relative">

        <div class="relative flex max-ml:flex-col">
          <div class=" relative">
            <h3 class="relative text-1.88rem font-semibold mb-7.4rem jsn-business-introduction-title">
              <span class="relative z-2">{{ content.businessIntroduction.subTitle }}</span>
            </h3>

            <ul class="features-group-ul">
              <li v-for="desc in content.businessIntroduction.descList"
                class="text-[#616671] text-[1rem] mb-[2rem] features-group-li w-[505px] max-ml:w-full">{{ desc
                }}
              </li>
            </ul>

          </div>
          <Pic class="w-[66rem] h-39.56rem translate-x-[116px] max-ml:w-full max-ml:h-auto max-ml:translate-x-0"
            :src="content.businessIntroduction.mainImage"></Pic>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full ">

      <h2 class="text-42.08px text-[#272E3B] pt-[80px] text-center bg-[#EFF7FF]">
        {{ content.featuresIntroduction.title }}
      </h2>

      <section :class="['py-3.56rem', group.direction === 'image-to-copywriting' ? 'bg-[#EFF7FF]' : '']"
        v-for="group in content.featuresIntroduction.groups">
        <PageContentCenter
          :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-350px relative top-1/2 align-self-center max-ml:w-full">
            <div :class="['mb-1.75rem']">
              <Pic :src="group.icon" class="w-[7rem] h-6.88rem mb-1.75rem max-lg:hidden"></Pic>
              <h4 class="text-1.88rem">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul">
              <li v-for="desc in group.descList" class="text-[#616671] text-[1rem] mb-[2rem] features-group-li">{{ desc
                }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.25rem max-ml:w-full" :src="group.mainImage"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <section class="relative w-full jsn-product-advantage h-58.13rem max-ml:h-[auto] max-ml:hidden">
      <h2 class="text-42.08px text-[#fff] pt-[80px] text-center mb-13.25rem ">
        {{ content.advantage.title }}
      </h2>
      <PageContentCenter class="text-[#272E3B] relative">
        <ul class="flex justify-center gap-2.44rem max-ml:flex-col max-ml:items-center">
          <li v-for="item in content.advantage.list"
            class="jsn-product-advantage-item max-ml:w-100%! relative max-ml:mb-180px">
            <Pic :src="item.icon" class="relative left-2.3rem w-19.38rem h-19.38rem mt-[-10rem] max-lg:left-auto"></Pic>
            <h5 class="text-center text-1.88rem font-semibold mt-0.75rem mb-1.83rem">{{ item.title }}</h5>
            <p class="text-left text-[#8F8F8F] text-0.88rem px-2.38rem mb-2.44rem h-3.75rem">{{
              item.desc }}</p>
            <h6 class="jsn-product-advantage-item-brief" :style="{ backgroundImage: `url('${item.briefBack}')` }">{{
              item.brief }}</h6>
          </li>
        </ul>
      </PageContentCenter>
    </section>

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { useSeoMeta } from 'nuxt/app'
import { shallowReactive } from 'vue'
useSeoMeta({
  title: '即时鸟',
  description: '即时鸟新零售系统',
})
const content = shallowReactive({
  businessIntroduction: {
    title: '产品业务介绍',
    // 副标题
    subTitle: '即时鸟新零售SaaS系统',
    desc: '即时鸟为便利店、餐饮店等实体门店提供一体化数字经营方案，可统一管理用户、商品、库存、订单及营销，应用于高校外卖跑腿、商家自配、区域承包配送、卖家收银等场景。 其中高校外卖满足学生 “懒、宅、忙” 需求，保障食品安全的同时节省了排队时间，更为学生提供了创业和就业机会；师生购物产生的积分可在专属商城兑换好物，进一步提升消费体验。',
    mainImage: '/images/pages/products/jsn/Frame 427321214@2x.png',
    descList: [
      '为便利店、餐饮店等实体门店提供一体化数字经营方案',
      '统一管理用户、商品、库存、订单及营销',
      '应用于高校外卖跑腿、商家自配、区域承包配送、卖家收银等场景',
      '高校外卖满足学生 “懒、宅、忙” 需求，保障食品安全的同时节省了排队时间，更为学生提供了创业和就业机会',
    ]
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    groups: [
      {
        title: '商品中心',
        desc: '',
        descList: [
          '支持移动化创建、查看和管理商品信息',
          '25W+免费商品资料库，涵盖零售各大细分行业',
          '输入条码自动识别，批量导入快速建档'
        ],
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-2796-.png',
        mainImage: '/images/pages/products/jsn/shzxxx@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '库存管理',
        desc: '',
        descList: ['提供线上销售库存管理，保证外卖订单有足够的库存', '减少线上订单缺货情况', '提高客户满意度',],
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-5801-.png',
        mainImage: '/images/pages/products/jsn/c321wzxx@2x.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '商家端',
        desc: '',
        descList: ['为商家和门店提供app，订单中心便捷管理', '财务报表一目了然', '实现商家掌上管理门店，提供便捷的同时提高工作效率',],
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-7469-.png',
        mainImage: '/images/pages/products/jsn/c1112313231@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '配送端',
        desc: '',
        descList: ['便捷查看及跟踪配送订单状态', '收益明细便捷查看', '系统根据配送员定位以及订单量智能分配订单',],
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-6605-.png',
        mainImage: '/images/pages/products/jsn/jsn- (3).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '财务中心',
        desc: '',
        descList: ['计算每一笔订单，以及每日门店收益、平台收益', '交易、分账环节有迹可循', '提高财务人员对账效率',],
        icon: '/images/pages/products/jsn/cw.png',
        mainImage: '/images/pages/products/jsn/cwzxx@2x.png',
        direction: 'image-to-copywriting'
      },
      {
        title: '商圈管理',
        desc: '',
        descList: ['可在地图规划商圈、电子围栏以及楼栋信息', '规范骑手配送范围、用户下单范围', '提高配送效率和用户体验',],
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-8257-sq.png',
        mainImage: '/images/pages/products/jsn/c1ddfs@2x.png',
        direction: 'copywriting-to-image'
      }, {
        title: '营销活动',
        desc: '',
        descList: ['门店可设置限时销售、限时折扣等营销活动', '提高用户回购率',],
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-7547ss.png',
        mainImage: '/images/pages/products/jsn/jsn- (2).png',
        direction: 'image-to-copywriting'
      }, {
        title: '派单中心',
        desc: '',
        descList: ['即时鸟配送可覆盖整个门店周边商圈，确保门店周边范围都可到达', '智能化派单逻辑以及客服派单系统', '订单分配合理化，响应及时'],
        icon: '/images/pages/products/jsn/pd-fi.png',
        mainImage: '/images/pages/products/jsn/jsn- (1).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    list: [
      {
        title: '商家资源整合',
        desc: '资源整合为商家提供多元曝光机会，营销支持和数据分析提升经营效率',
        brief: '超便利',
        briefBack: '/images/pages/products/jsn/Group 1171274811@2x.png',
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-7469-一套3d立体毛玻璃icon，主色为蓝白色，保持角度一致风格一致，背景为白色：ic... 2@2x.png'
      },
      {
        title: '私域流量运营',
        desc: '建立商家私域流量池、提升订单量和用户复购‌，定期对私域开展营销活动',
        brief: '私域定制',
        briefBack: '/images/pages/products/jsn/Group 1171274812@2x.png',
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-7469-一套3d立体毛玻璃icon，主色为蓝白色，保持角度一致风格一致，背景为白色：ic... 4@2x.png'
      },
      {
        title: '商品结构优化',
        desc: '优化商品结构提升抢单效率，高质量服务培训和评估策略',
        brief: '高效率',
        briefBack: '/images/pages/products/jsn/Group 1171274813@2x.png',
        icon: '/images/pages/products/jsn/jimeng-2025-10-23-7469-一套3d立体毛玻璃icon，主色为蓝白色，保持角度一致风格一致，背景为白色：ic... 3@2x.png'
      },

    ]
  }
})
</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-jsn-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .jsn-product-advantage-item {
    width: 28.38rem;
    height: 21.38rem;
    border-radius: 1.25rem 1.25rem 0 0;
    background: linear-gradient(180deg, #d0e8ff 0%, #fff 100%);

    .jsn-product-advantage-item-brief {
      width: 100%;
      height: 5.56rem;
      border-radius: 0 0 1.25rem 1.25rem;
      background-size: cover;
      color: #fff;
      font-size: 1.5rem;
      font-weight: bold;
      line-height: 5.56rem;
      text-align: center;
    }
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 4px;
        left: 0;
        width: 1.06rem;
        height: 1.06rem;
        background-image: url("/images/pages/products/jsn/Frame 1171274835@2x.png");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
      }
    }
  }
}

.jsn-business-introduction-title {
  position: relative;
  padding-left: 20px;

  &::before {
    position: absolute;
    z-index: 0;
    top: 10px;
    left: 0;
    width: 0.25rem;
    height: 1.5rem;
    border-radius: 0;
    background: #1967f9;
    content: "";
  }

  &::after {
    position: absolute;
    z-index: 0;
    top: -48px;
    left: 69px;
    width: 18.38rem;
    height: 4.44rem;
    color: #f4f8ff;
    content: "BUSINESS";
    font-size: 3.38rem;
    font-style: normal;
    font-weight: 800;
    text-align: left;
    text-transform: none;
  }
}

.jsn-product-advantage {
  background-image: url("/images/pages/products/jsn/Group 1171274840@2x.png");
  background-size: cover;
}
</style>
